import Vue from "vue";
import store from './store';
import VueRouter from "vue-router";
import App from "./App.vue";
import i18n from './i18n';

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

// router setup
import routes from "./routes/routes";

import "./registerServiceWorker";
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'
Vue.prototype.$iziToast = iziToast // Glopal variable
Vue.use(iziToast)

// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);

// configure router
const router = new VueRouter({
  mode: "history", // Set the mode to "history" for history mode
  routes,
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

new Vue({
  el: "#app",
  store,
  i18n,
  render: (h) => h(App),
  router,
});
